export const CodeExample = {
  extends: 'Flex',
  round: 'A1',
  overflow: 'hidden',
  CodePreview: {}
}
